module.exports = __webpack_public_path__ + "img/03.c1d65940.png";